import itemGroupSearch from "./itemGroupSearch";
import itemGroupList from "./itemGroupList";
import service from "./../../../services/warehouse/itemGroup"
export default {
    namespaced: true,
    modules: {
        search: itemGroupSearch,
        list: itemGroupList
    },
    state: {
        itemGroups: []
    },

    getters: {
        itemGroups: state => state.itemGroups
    },
    mutations: {
        setItemGroups: (state, payload) => state.itemGroups = payload,
        addItemGroup: (state, payload) => state.itemGroups.push(payload),
        replaceItemGroup: (state, payload) => {
            let itemGroups = [...state.itemGroups];
            let itemGroup = itemGroups.find(each => each.id.toString() == payload.id.toString());
            let index = itemGroups.indexOf(itemGroup);
            itemGroups[index] = payload;
            state.itemGroups = [...itemGroups];
        },
        removeItemGroup: (state, payload) => {
            let itemGroups = [...state.itemGroups];
            let itemGroup = itemGroups.find(each => each.id == payload.id);
            let index = itemGroups.indexOf(itemGroup);
            itemGroups.splice(index, 1);
            state.itemGroups = [...itemGroups];
        }
    },
    actions: {
        create(context, payload) {
            return new Promise((resolve, reject) => {
                service.create(payload)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                service.findByID(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                service.update(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        remove(context, payload) {
            return new Promise((resolve, reject) => {
                service.remove(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}